import { cloneElement, isValidElement } from 'react'

import type {
  RadioCardImageValue,
  RadioCardVariant,
} from '@ui-kit/components/formComponents/RadioCardSet/types'
import { COLOR } from '@ui-kit/constants'

export const withInvertedIcon = (
  image: RadioCardImageValue | undefined,
  variant: RadioCardVariant | undefined,
  isSelected: boolean
) =>
  variant === 'chip' && isSelected && isValidElement<{ color?: string }>(image)
    ? cloneElement(image, { color: COLOR.white })
    : image
